import { render, staticRenderFns } from "./DbiRouterView.vue?vue&type=template&id=7da03edf&scoped=true&"
import script from "./DbiRouterView.vue?vue&type=script&lang=ts&"
export * from "./DbiRouterView.vue?vue&type=script&lang=ts&"
import style0 from "./DbiRouterView.vue?vue&type=style&index=0&id=7da03edf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da03edf",
  null
  
)

export default component.exports